module.exports = __webpack_public_path__ + "img/02.a8d427d3.png";